export function initializeToggleGallery() {
  const items = document.querySelectorAll(".grid-item");
  const images = document.querySelectorAll(".how-to-img-item");
  let activeIndex = 1;

  items.forEach((item) => {
    item.addEventListener("click", () => {
      const newIndex = item.dataset.index;
      if (newIndex == activeIndex) return;

      // update active states
      items.forEach(i => i.classList.remove("active"));
      item.classList.add("active");

      const oldImg = document.querySelector(`.how-to-img-item[data-index="${activeIndex}"]`);
      const newImg = document.querySelector(`.how-to-img-item[data-index="${newIndex}"]`);

      // animate transition with GSAP
      gsap.to(oldImg, {
        duration: 0.5,
        opacity: 0,
        x: -30,
        onComplete: () => {
          oldImg.classList.remove("active");
          gsap.set(oldImg, { x: 0 });
        }
      });

      gsap.fromTo(newImg,
        { opacity: 0, x: 30 },
        {
          duration: 0.5,
          opacity: 1,
          x: 0,
          onStart: () => newImg.classList.add("active")
        }
      );

      activeIndex = newIndex;
    });
  });

}

